import { useEffect, useState } from "react";

export enum ViewportType {
  Mobile = "Mobile",
  Tablet = "Tablet",
  TabletLandscape = "TabletLandscape",
  Desktop = "Desktop",
}

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const getViewport = (width: number): ViewportType => {
    if (width < 481) {
      return ViewportType.Mobile;
    } else if (width < 769) {
      return ViewportType.Tablet;
    } else if (width < 1025) {
      return ViewportType.TabletLandscape;
    } else {
      return ViewportType.Desktop;
    }
  };

  const [viewportType, setViewportType] = useState(getViewport(windowSize.width));

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      setViewportType(getViewport(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { windowSize, viewportType };
};
